/**
 * Escapes text so it can go inside HTML markup or a quoted attribute value.
 *
 * SECURITY: use this for EVERY user-entered value (names, blurbs, security
 * questions, match messages, server messages that may echo user input) that
 * is placed into an HTML string for innerHTML, dasModal.render, or
 * iPop.render. Or set the value with textContent instead.
 *
 * This module has no imports on purpose, so any module can import it without
 * creating an import cycle (see "circular imports" in lessons learned).
 * @param {*} value
 * @returns {string}
 */
export const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

/**
 * Backstop for dasModal.render and iPop.render: true if an HTML string has
 * markup that runs code (script/iframe/object/embed tags, inline on...=
 * handlers, javascript: URLs, srcdoc). The app's own templates never use
 * these. Escaped user text can't trip it, because escaped text has no "<".
 * This is defense in depth only; escaping user values is the real fix.
 * @param {string} html
 * @returns {boolean}
 */
export const hasDangerousMarkup = (html) =>
  /<\s*\/?\s*(script|iframe|object|embed)\b/i.test(html) ||
  /<[^>]*[\s/]on[a-z]+\s*=/i.test(html) ||
  /<[^>]*(javascript|vbscript)\s*:/i.test(html) ||
  /<[^>]*\ssrcdoc\s*=/i.test(html);
